import React, { useContext, useEffect, useState } from "react";
import { LatencyChart } from "./LatencyChart";
import { TestsContext, TargetsContext } from "../../contexts";
import { Stat, Box } from "../common";
import { calculateAverage } from "../../utilities";
import { Link } from "react-router-dom";
import { Location } from "../common";
import { Row, Col } from "react-bootstrap";

/** Init the data for the chart.
 *
 */
//const initJitter = (tests) => {};

export const Test = (props) => {
  let targets = useContext(TargetsContext);
  let { tests } = useContext(TestsContext);
  const { index } = props;
  const [latency, setLatency] = useState(0);
  const [jitter, setJitter] = useState(0);
  const { area, country } = targets[index];

  const hasData = tests !== null && Array.isArray(tests.times) && Array.isArray(tests.times[index]);

  /** Initialize data and stats.
   */
  useEffect(() => {
    if (hasData) {
      // Calculate the jitter from the times data.
      let jitter = [];
      for (var n = 0; n < tests.times[index].length - 1; ++n) {
        jitter.push(Math.trunc(Math.abs(tests.times[index][n] - tests.times[index][n + 1])));
      }

      // Get the latency and jitter averages.
      setLatency(Math.trunc(calculateAverage(tests.times[index])));
      setJitter(Math.trunc(calculateAverage(jitter)));
    }
  }, [tests, index, hasData]);

  /** Generate a tag id from the location.
   */
  const generateID = () => {
    const loc = targets[index].id;
    return `detail-${loc.toLowerCase()}`;
  };

  return (
    <>
      <div className='w-100'>
        <Location index={index} />
      </div>
      <Box className='p-2'>
        <Row>
          <Col className='col-9'>
            <LatencyChart index={index}></LatencyChart>
          </Col>
          <Col>
            <Row>
              <Col>
                <Stat title='Latency' value={latency} />
              </Col>
              <Col>
                <Stat title='Jitter' value={jitter} />
              </Col>
            </Row>
            <Link id={generateID()} to={`/detail-testing/${index}`}>More Details</Link>
          </Col>
        </Row>
      </Box>
    </>
  );
};
